import React, { useEffect, useRef, useState } from 'react'
import Header from './Header/Header'
import TopSlider from '../pages/TopSlider'
import Right from '../assests/images/arrow_right.png'
import Cookies from 'js-cookie';
import Loader from '../assests/images/loader.gif'
import cross from '../assests/images/cross.svg'
import invalid from '../assests/images/invalid.gif'
import { Games, Register, verifyCode } from '../utils/Api';
import GameList from './GameList'
import { Link } from 'react-router-dom'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { DataContext } from '../context/DataContext';
import success2 from '../assests/images/success2.gif'
import M from 'materialize-css';
import Footer from './footer/Footer';


const MainSection = () => {
  const modalRef = useRef(null);
  const modalRef1 = useRef(null);
  const modalRef2 = useRef(null);
  const [isClicked, setIsClicked] = useState(false);
  // const hasShownModalRef = useRef(false);
  const [code, setCode] = useState('');
  const { data, loading, error, refetch, setAndroidId, androidId } = useContext(DataContext);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!loading) {
      console.log('data', data);
    }
  }, [loading])
  // const Listing = useMutation({
  //   mutationFn: Games,
  //   onSuccess: (data) => {
  //     queryClient.setQueryData(['Games'], data);
  //   },
  // });

  // const { data: userRegistered, loading: userRegisteredLoading, error: gameuserRegisteredError, refetch: userRegisteredRefetch } = useQuery({
  //   queryKey: ['userRegister'],
  //   queryFn: async () => await Register()
  // })

  const { data: gameList, isLoading: gameListLoading, isError: gameListError, refetch: gameListRefatch } = useQuery({
    queryKey: ['allGameList'],
    queryFn: async () => await Games(data?.user_id),
    enabled: !!(data?.user_id || data?.user_id == 0)
  })

  const { mutate, isPending } = useMutation({
    mutationFn: async (inputCode) => await verifyCode({ android_id: androidId, verification_code: code }),
    onSuccess: (data) => {
      if (modalRef1.current && modalRef2.current) {
        if (data.status == 0) {
          const instance = M.Modal.init(modalRef2.current, {
          });
          setCode('');
          instance.open();
          setIsClicked(false);
        } else {

          const instance = M.Modal.init(modalRef1.current, {
          });
          const instance2 = M.Modal.init(modalRef.current, {});
          instance2.close();
          setCode('');
          instance.open();
          refetch(androidId);
          setIsClicked(false);
        }
        // alert('refetched');
      }
    },
    onError: (err) => {
      if (modalRef2.current) {
        const instance = M.Modal.init(modalRef2.current, {
        });
        setCode(null);
        instance.open();
        setIsClicked(false);
      }
    }
  })


  // if (!userRegisteredLoading) {
  //   console.log('register', userRegistered);
  // }

  // useEffect(() => {
  //   Listing.mutate({ user_id: data, idtoken: data });
  // }, [data]);

  // const List = queryClient.getQueryData(["Games"]);

  // useEffect(() => {
  //   if (modalRef.current) {
  //     const instance = M.Modal.init(modalRef.current, {
  //     });
  //     instance.open();
  //   }
  // }, []);

  const handleSuccess = (e) => {
    if (modalRef1.current) {
      const instance = M.Modal.init(modalRef1.current, {
      });
      instance.open();
    }
    e.preventDefault();
    const code = document.querySelector('input[name="Code"]').value;
    const instance = M.Modal.getInstance(modalRef.current);
    instance.close();
  };

  const codeVerify = () => {
    mutate(code);
  }
  // console.log('Games', List)

  useEffect(() => {
    const hasShown = sessionStorage.getItem('hasShownVerifyModal');

    if (!gameListLoading && !loading && data?.is_verified == '0' && !hasShown) {
      const timeout = setTimeout(() => {
        if (modalRef.current) {
          const instance = M.Modal.init(modalRef.current, {
            dismissible: false,
          });
          instance.open();
          // M.Modal.init(modalRef.current, {
          //   dismissible: true,
          // });
          sessionStorage.setItem('hasShownVerifyModal', 'true');
        }
      }, 200);
      return () => clearTimeout(timeout);
    }
  }, [gameListLoading]);



  if (gameListLoading || loading) return <div className="body_area22">
    <div className="cointainr loader">
      <img src={Loader}></img>
    </div></div>;

  if (error) return <p className='errorText'>Error: {error.message}</p>;

  return (
    <>
      <Header name={gameList?.user_name?.trim() !== '' ? gameList?.user_name : 'You'} image={gameList && gameList.user_image} dval={gameList ? gameList.diamond_balance : '0'}></Header>
      <div className="body_area22">
        <div className="cointainr">
          {gameList && <div>
            <TopSlider type={0} topgames={gameList?.result?.banner_games}></TopSlider>
            <div className="body_area">
              <div className="d_flx2">
                <h2 className="main_ttl">
                  Top<p>Trending</p>
                </h2>
              </div>
              <TopSlider type={1} trending={gameList?.result?.trending_games}></TopSlider>
            </div>
            <div className="featured_games mt_10per">
              <div className="d_flx2">
                <h2 className="main_ttl">
                  Featured<p>Games</p>
                </h2>
                <Link to={'/viewAllFeatured'} className="view_more">
                  view all
                  <div className="view_more_btn">
                    <img src={Right} alt="view more" />
                  </div>
                </Link>
              </div>
              <p className="desc max_wdth">
                Top Air combat game where you defeat enemies using bullets and missiles
                while advancing. Dodge enemy weapons to stay alive.
              </p>
              <TopSlider type={2} featured={gameList?.result?.featured_games}></TopSlider>
            </div>
            <div className="column_area mrgin_top">
              <div className="d_flx2">
                <h2 className="main_ttl">
                  All<p>Games</p>
                </h2>
                <Link to={'/viewAll'} className="view_more">
                  view all
                  <div className="view_more_btn">
                    <img src={Right} alt="view more" />
                  </div>
                </Link>
              </div>
              <GameList gamel={gameList.result.all_games}></GameList>
            </div>
          </div>}

          {/* for verify code      */}
          {/* { */}
          {/* // data?.is_verified === '0' && ( */}
          {/* <> */}
          <div ref={modalRef} id="modal12" className="modal bottom-sheet">
            <div className="modal-content">
              <div class="d_flx2">
                <h2 class="main_ttl">Verify Your<p>Code</p></h2>
                <a href="#" class="modal-close">
                  <img src={cross} alt="cross" class="flt_50" />
                </a>
              </div>
              <p class="desc">For your security, enter the code from the connected app to verify and proceed.</p>
              {
                !isClicked && (
                  <a href="https://cash.minipay.xyz/browse?url=https://games.gamiflykash.xyz/Instruction/0">
                    <button onClick={() => setIsClicked(true)} class="play_now">
                      Get Code
                    </button>
                  </a>
                )
              }

              <div>
                <div className="input-field col s12">
                  <input
                    placeholder="Enter your code..."
                    id="Email"
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="validate input_name"
                    name="Code"
                  />
                </div>
                {
                  code?.trim() == '' ? (<button onClick={codeVerify} type="submit" disabled className={`play_now ${isClicked ? '' : 'completed_btn'}`}>
                    Proceed
                  </button>) : (<button onClick={codeVerify} type="submit" className={`play_now ${isClicked ? '' : 'completed_btn'}`}>
                    Proceed
                  </button>)
                }
                {/* <button onClick={codeVerify} type="submit" className={`play_now ${isClicked ? '' : 'completed_btn'}`}>
                  Proceed
                </button> */}

                {
                  isClicked && (
                    <>
                      <p className='desc center'>Don't have an code?</p>
                      <a href="https://cash.minipay.xyz/browse?url=https://games.gamiflykash.xyz/Instruction/0">
                        <button class="play_now completed_btn">
                          Get Code Again
                        </button>
                      </a>
                    </>
                  )
                }

              </div>
            </div>
          </div>

          {/* code verified success */}
          <div ref={modalRef1} id="modal3" className="modal bottom-sheet modal_text ">
            <div className="d_flx2">
              <h2 className="main_ttl" />
              <a href="#" className="modal-close">
                <img src={cross} alt="cross" className="flt_50" />
              </a>
            </div>
            <div className="d_flex center_align">
              <img src={success2} alt="success" className="gif_colr_chnge" />
              <h2 className="main_ttl">Code Verified Successfully</h2>
              <p className="desc center">
                Your code has been verified. <br></br>You’re all set to continue using the app!
              </p>
              <a href="#" className="play_now completed_btn brdr_10 modal-close">
                Close
              </a>
            </div>
          </div>
          {/*  invalid code   */}
          <div ref={modalRef2} id="modal3" className="modal bottom-sheet modal_text ">
            <div className="d_flx2">
              <h2 className="main_ttl" />
              <a href="#" className="modal-close">
                <img src={cross} alt="cross" className="flt_50" />
              </a>
            </div>
            <div className="d_flex center_align">
              <img src={invalid} alt="success" className="gif_colr_chnge invalid" />
              <h2 className="main_ttl">Invalid Code Entered</h2>
              <p className="desc center">
                Please double-check the code and enter it again to verify your account.
              </p>
              <a href="#" className="play_now completed_btn brdr_10 modal-close">
                Close
              </a>
            </div>
          </div>
          {/* </> */}
          {/* ) */}
          {/* // } */}




          <Footer></Footer>
        </div>
      </div >
    </>

  )
}

export default MainSection
